// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "div.blatt___21QzC {\n  z-index: 10;\n  float: right;\n  position: absolute;\n  color: #FFF;\n  text-align: center;\n  font-size: 40px;\n  line-height: 1;\n  cursor: pointer;\n}\ndiv.blatt___21QzC:hover {\n  color: #DDD;\n}\n", "",{"version":3,"sources":["MainSelection.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb","file":"MainSelection.less","sourcesContent":["div.blatt {\n  z-index: 10;\n  float: right;\n  position: absolute;\n  color: #FFF;\n  text-align: center;\n  font-size: 40px;\n  line-height: 1;\n  cursor: pointer;\n}\ndiv.blatt:hover {\n  color: #DDD;\n}\n"]}]);
// Exports
exports.locals = {
	"blatt": "blatt___21QzC"
};
module.exports = exports;
